import { IBaseNotification } from "../types";
import { BaseNotificationModel } from "./base-notification-model";

export class SubscriptionNotificationModel extends BaseNotificationModel {

  constructor(notification: IBaseNotification) {
    super(notification);
  }
  
  async show() {
    this.markAsDelivered();
    this.dispatchCompleteEvent();
  }
}
